import { useMemo as s } from "react";
import { apiClient as y } from "../provider/create-provider.js";
import { createFieldMapper as P } from "../utils/directus-field-mapper.js";
const { map: M, fields: j } = P()({
  _all: !0,
  og_image: {
    _all: !0
  }
}), k = ["canonical_url", "og_url"];
function v(l) {
  const f = s(() => {
    const n = ((l == null ? void 0 : l.path.split("/")) ?? []).reduce((e, i) => {
      const t = e.length ? e[e.length - 1] : "";
      return i ? (e.push(
        !t || t === "/" ? "/" + i : [t, i].join("/")
      ), e) : ["/"];
    }, []);
    return n.reverse(), n;
  }, [l == null ? void 0 : l.path]), { isLoading: g, isError: _, isPending: h, isPaused: d, isSuccess: r, error: p, data: o } = y.items.readItemsMetadata.useQuery(
    {
      query: {
        fields: j,
        filter: [
          JSON.stringify({
            path: {
              _in: f
            }
          })
        ]
      }
    },
    { enabled: !(l != null && l.pause) }
  );
  return {
    isLoading: g,
    isError: _,
    isPending: h,
    isPaused: d,
    isSuccess: r,
    error: p,
    data: s(() => {
      const u = M(o == null ? void 0 : o.data);
      return u.sort((n, e) => {
        var i, t;
        return (((i = e == null ? void 0 : e.path) == null ? void 0 : i.length) ?? 0) - (((t = n == null ? void 0 : n.path) == null ? void 0 : t.length) ?? 0);
      }), u.reduce(
        (n, e) => {
          if (!e)
            return n;
          for (const i of Object.keys(n)) {
            const t = i;
            if (!(e.path !== (l == null ? void 0 : l.path) && k.includes(t)) && e[t]) {
              if (t === "no_follow" || t === "no_index") {
                n[t] = n[t] ?? e[t] ?? !1;
                continue;
              }
              if (typeof e[t] == "string" || t !== "og_image") {
                n[t] = (n[t] ?? e[t].trim()) || null;
                continue;
              }
              if (t === "og_image") {
                n[t] = Object.keys(e[t]).length ? e[t] : n[t];
                continue;
              }
              n[t] = n[t] ?? e[t];
            }
          }
          return n;
        },
        {
          meta_description: null,
          title: null,
          path: null,
          canonical_url: null,
          og_title: null,
          og_url: null,
          og_description: null,
          og_image: null,
          no_follow: null,
          no_index: null
        }
      );
    }, [o == null ? void 0 : o.data])
  };
}
export {
  v as useMetadata
};
